import React from 'react';
import {NavLink} from 'react-router-dom';


/**
 *
 */
class Navigation extends React.PureComponent {

    state = {
        opened: false,
        offset: false
    };

    /**
     *
     */
    componentDidMount() {
        window.addEventListener('resize', this.close);
        window.addEventListener('scroll', this.scroll);
        this.scroll();
    }

    /**
     *
     */
    componentWillUnmount() {
        window.removeEventListener('resize', this.close);
        window.removeEventListener('scroll', this.scroll);
    }

    /**
     * @returns {*}
     */
    render = () => (
        <>
            <div className='Navigation__helper'/>
            <div className={`Navigation ${this.state.offset && 'Navigation--offset'}`}>
                <div className='Container'>
                    <button type='button'
                            onClick={this.toggle}
                            className={`Navigation__button ${this.state.opened && 'Navigation__button--opened'}`}>
                        Otevřít menu
                    </button>
                    <ul className={`Navigation__list ${this.state.opened && 'Navigation__list--opened'}`}>
                        <li className='Navigation__item'>
                            <NavLink to='/'
                                     onClick={this.close}
                                     exact
                                     activeClassName='Navigation__link--selected'
                                     className='Navigation__link'>
                                Aktuality
                            </NavLink>
                        </li>
                        <li className='Navigation__item'>
                            <NavLink to='/projekty'
                                     onClick={this.close}
                                     exact
                                     activeClassName='Navigation__link--selected'
                                     className='Navigation__link'>
                                Projekty
                            </NavLink>
                        </li>
                        <li className='Navigation__item'>
                            <NavLink to='/o-spolku/'
                                     onClick={this.close}
                                     exact
                                     activeClassName='Navigation__link--selected'
                                     className='Navigation__link'>
                                O Spolku
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );

    /**
     *
     */
    scroll = () => {
        const doc = document.documentElement;
        const offset = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        this.setState({offset: offset > 2});
    };

    /**
     *
     */
    close = () => {
        this.setState({opened: false});
    };

    /**
     *
     */
    toggle = () => {
        this.setState({opened: !this.state.opened});
    };
}


export default Navigation;